/**
 * BlockTitle — tiêu đề "block" kiểu Batch Report (`batchReport/tabs/reportUi`):
 * thanh accent teal + chữ teal in hoa, weight 800, letterSpacing 0.8. Dùng chung
 * cho các block name của Factory Summary (ReportCard + sơ đồ kho).
 */
import { Box, Typography } from '@mui/material'

const TEAL = '#145a59'

export function BlockTitle({ title }: { title: string }) {
  return (
    <Typography
      component="div"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        mb: 0.75,
        pl: 0.25,
        fontSize: '0.7rem',
        fontWeight: 800,
        letterSpacing: 0.8,
        textTransform: 'uppercase',
        color: TEAL,
      }}
    >
      <Box component="span" sx={{ width: 3, height: 13, borderRadius: 1, bgcolor: TEAL }} />
      {title}
    </Typography>
  )
}
